<template>
    <!-- Breadcrumb Section Start -->
    <section class="breadscrumb-section pt-0">
        <div class="container-fluid-lg">
            <div class="row">
                <div class="col-12">
                    <div class="breadscrumb-contain">
                        <h2>{{ $t('Edit my data') }}</h2>
                        <nav>
                            <ol class="breadcrumb mb-0">
                                <li class="breadcrumb-item active">{{ $t('Edit my data') }}</li>
                                <li class="breadcrumb-item">
                                    <router-link :to="{name: 'home', params: { lang : $i18n.locale }}" >
                                        <i class="fa-solid fa-house"></i>
                                    </router-link>
                                </li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- Breadcrumb Section End -->

    <!-- log in section start -->
    <section class="log-in-section section-b-space forgot-section">
        <div class="container-fluid-lg w-100">
            <div class="d-flex align-items-center justify-content-center h-100">
                <div class="log-in-box">

                    <alertErrors :errors="validationErrors" v-if="validationErrors"></alertErrors>

                    <div class="input-box">
                        <form class="row g-4" @submit.prevent="update">

                            <div class="col-12">
                                <div class="form-floating theme-form-floating log-in-form">
                                    <input type="text" class="form-control" id="name"
                                           :placeholder="$t('Name')" v-model="user.name" :class="{ 'is-invalid' : isInvalid('name')}" required>
                                    <div class="invalid-feedback" v-if="isInvalid('name')">
                                        {{  isInvalid('name') }}
                                    </div>
                                    <label for="name">{{ $t('Name') }}</label>
                                </div>
                            </div>

                            <div class="col-12">
                                <div class="form-floating theme-form-floating log-in-form">
                                    <input type="text" class="form-control pe-1" id="login-email" placeholder=""
                                           aria-label="email" aria-describedby="email" v-model="user.email" :class="{ 'is-invalid' : isInvalid('email')}" dir="ltr">
                                    <div class="invalid-feedback" v-if="isInvalid('email')">
                                        {{  isInvalid('email') }}
                                    </div>

                                    <label for="login-email">{{ $t('Email') }}</label>
                                </div>
                            </div>


                            <div class="col-12">
                                <div class="form-floating theme-form-floating log-in-form">
                                    <input type="text" class="form-control pe-1" id="login-mobile" placeholder="5×××××"
                                           aria-label="mobile" aria-describedby="mobile" v-model="user.mobile" :class="{ 'is-invalid' : isInvalid('mobile')}" dir="ltr">
                                    <div class="invalid-feedback" v-if="isInvalid('mobile')">
                                        {{  isInvalid('mobile') }}
                                    </div>

                                    <label for="login-mobile">{{ $t('Phone number') }}</label>
                                </div>
                            </div>


                            <div class="col-12">
                                <button class="btn btn-animation w-100" type="submit">{{ $t('Save') }}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- log in section end -->
<!--        <div class="card border-0 mb-5">-->
<!--            <div class="card-title text-brand-primary bg-brand-primary-faint p-3">-->
<!--                <i class="icon-user me-2 ms-2  fo-x-large float-start"></i>-->
<!--                الملف الشخصي-->
<!--            </div>-->
<!--            <div class="card-body d-flex justify-content-center">-->

<!--                <div class="col-lg-9 col-12">-->


<!--                    <form  class="w-100">-->

<!--                        <div class="mb-3 row">-->
<!--                            <label for="user-name" class="col-sm-3 col-form-label pt-2">الدولة</label>-->
<!--                            <div class="col-sm-9">-->

<!--                                <select class="form-select"  :class="{ 'is-invalid' : isInvalid('country_code')}" v-model="item.country_code">-->
<!--                                    <option value="" selected disabled hidden style="display: none;"></option>-->
<!--                                    <option v-for="option in form_options?.country_code" :value="option.id" :selected="item.country_code == option.id">{{ option.code }}</option>-->
<!--                                </select>-->

<!--                                <div class="invalid-feedback" v-if="isInvalid('country_code')">-->
<!--                                    {{  isInvalid('country_code') }}-->
<!--                                </div>-->

<!--                            </div>-->
<!--                        </div>-->


<!--                        <div class="mb-3 row">-->
<!--                            <label for="user-mail" class="col-sm-3 col-form-label pt-2">البريد الإلكتروني</label>-->
<!--                            <div class="col-sm-9">-->
<!--                                <input type="email" class="form-control" :class="{ 'is-invalid' : isInvalid('email')}" v-model="item.email">-->
<!--                                <div class="invalid-feedback" v-if="isInvalid('email')">-->
<!--                                    {{  isInvalid('email') }}-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->

<!--                        <div class="mb-3 row">-->
<!--                            <label for="user-country" class="col-sm-3 col-form-label pt-2">البلد</label>-->
<!--                            <div class="col-sm-9">-->
<!--                                <select class="form-select  " aria-label="user-country" id="user-country">-->
<!--                                    <option selected>السعودية</option>-->
<!--                                </select>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                        <div class="mb-3 row">-->
<!--                            <label for="user-mobile" class="col-sm-3 col-form-label pt-2">رقم الهاتف</label>-->
<!--                            <div class="col-sm-9">-->
<!--                                <input type="tel" class="form-control" :class="{ 'is-invalid' : isInvalid('mobile')}" v-model="item.mobile">-->
<!--                                <div class="invalid-feedback" v-if="isInvalid('mobile')">-->
<!--                                    {{  isInvalid('mobile') }}-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                        <div class="mb-3 row">-->
<!--                            <label for="bio" class="col-sm-3 col-form-label pt-2">نبذة</label>-->
<!--                            <div class="col-sm-9">-->
<!--                                <textarea rows="3" class="form-control " id="bio"  :class="{ 'is-invalid' : isInvalid('bio')}" v-model="item.bio"></textarea>-->
<!--                                <div class="invalid-feedback" v-if="isInvalid('bio')">-->
<!--                                    {{  isInvalid('bio') }}-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                        <div class="mb-3 row">-->
<!--                            <div class="col-sm-9 offset-sm-3">-->
<!--                                <button type="submit" class="px-5 btn btn-brand-primary col-9 col-md-12">حفظ</button>-->
<!--                            </div>-->
<!--                        </div>-->

<!--                    </form>-->
<!--                </div>-->
<!--            </div>-->
<!--        </div>-->
</template>

<script>
//import Apptoast from "../handling/toast";
import { useToast } from "vue-toastification";
const toast = useToast();

import alertErrors from "../handling/alert-errors";

export default {
    inject: ['auth'],
    components: {
        alertErrors,
    },
    data() {
        return {
            user: {},
            form_options: {},
            avatar: null,
            cover: null,
            validationErrors: null,
        }
    },
    created() {

        // if(this.auth.isLoggedIn() === false){
        //     this.$router.push({name: 'home'});
        // }

        axios.get('users/edit' , {}).then(response => {
            this.user = response.data.data;
            this.form_options = response.data.elements;
        }, response => {

        });
    },
    watch: {
        '$userLoggedIn.value': function (newVal) {
            if(newVal === false){
                this.$router.push({name: 'home'});
            }
        },
        'avatar': function () {

            if(this.avatar != null) {
                let formData = new FormData();
                formData.append('avatar', this.avatar);

                const id = toast.info({
                    props: {content: 'uploading ...'},
                }, {icon: 'fa-solid fa-cloud-arrow-up'});

                axios.post(`users/upload/avatar`,
                    formData
                ).then(response => {
                    toast.dismiss(id);

                    toast.success(response.data.message, {
                        timeout: 3000,
                    }, {icon: 'fa-solid fa-circle-check'});


                    this.auth.reGetUser();
                    this.avatar = null;

                }).catch(function (error) {
                    toast.dismiss(id);
                    if (error.response) {
                        toast.error(error.response.data.message, {
                            timeout: 3000,
                        }, {icon: 'fa-solid fa-circle-exclamation'});
                    }
                });
            }

        },
        'cover': function () {

            if(this.cover != null){

                console.log(this.cover);
                let formData = new FormData();
                    formData.append('cover', this.cover);

                const id = toast.info({
                    props: { content: 'uploading ...' },
                },{ icon: 'fa-solid fa-cloud-arrow-up'  });

                axios.post(`users/upload/cover`   ,
                    formData
                ).then(response => {
                    toast.dismiss(id);

                    toast.success(response.data.message  ,{
                        timeout: 3000,
                    },{ icon: 'fa-solid fa-circle-check'  });


                    this.auth.reGetUser();
                    this.cover = null;

                }) .catch(function (error) {
                    toast.dismiss(id);
                    if (error.response) {
                        toast.error(error.response.data.message  ,{
                            timeout: 3000,
                        },{ icon: 'fa-solid fa-circle-exclamation'  });
                    }
                });

            }
        },
    },
    methods: {
        isInvalid( name ) {
            return this.validationErrors != null ? this.validationErrors[name]?.join() : false;
        },
        update() {

            const id = toast.info({
                props: { content: 'saving ...' },
            },{ icon: 'fa-solid fa-cloud-arrow-up'  });

            const that = this;
            this.validationErrors = null;

            let formData = new FormData();
            Object.entries(this.user).forEach(([key, value]) => {
                formData.append(key, value);
            });

            axios.post(`users/update`   ,
                formData
            ).then(response => {
                toast.dismiss(id);

                toast.success(response.data.message  ,{
                    timeout: 3000,
                },{ icon: 'fa-solid fa-circle-check'  });

                this.auth.reGetUser();
            }) .catch(function (error) {
                toast.dismiss(id);
                if (error.response) {
                    that.validationErrors = error.response.data.errors ;
                    toast.error(error.response.data.message  ,{
                        timeout: 3000,
                    },{ icon: 'fa-solid fa-circle-exclamation'  });
                }
            });
        }
    }
}
</script>
